import { Directive, ElementRef, HostListener } from '@angular/core';


@Directive({
  selector: '[numberSeparator]',
  standalone: true
})
export class NumbersSeparatorDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: any) {
    const initialValue = this._el.nativeElement.value;
    this._el.nativeElement.value = initialValue.getJustNumbersAndComma();



    if (initialValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
    else if (typeof (initialValue) !== "number") {
      let number = +initialValue.replaceAll(',', '');
      this._el.nativeElement.value = number.toLocaleString();
    }


  }

}

